import dayjs from "dayjs";
import { Common } from "../../../common/src";

export default class FormatUtil {
  static valFormat = (d: Date, lan: boolean) => {
    if (typeof (d) !== "string") {
      if (d.getTime() === 0) {
        return '-/-/-';
      }
    }

    return lan ? (dayjs(d).format(`YY/MM/DD HH:mm`)) : (dayjs(d).format(`DD/MM/YY HH:mm`));
  }

  static removeDecimalPoint = (num: number, numFix: number) => {
    return (num).toFixed(numFix);
  }

  static dateFormat = (d: Date, lan: boolean) => {
    return lan ? (dayjs(d).format(`YYYY/MM/DD HH:mm`)) : (dayjs(d).format(`DD/MM/YYYY HH:mm`));
  }

  static dateFormat1 = (d: Date, lan: boolean) => {
    return lan ? (dayjs(d).format(`YYYY/MM/DD HH:mm:ss`)) : (dayjs(d).format(`DD/MM/YYYY HH:mm:ss`));
  }

  static reqStringForPointCloud = (type: Common.POINT_CLOUD_TYPE) => {
    switch (type) {
      case Common.POINT_CLOUD_TYPE.SIMPLE:
        return "LiDAR";
      case Common.POINT_CLOUD_TYPE.SFM:
        return "SfM";
      case Common.POINT_CLOUD_TYPE.HELMERT:
        return "Helmert";
      case Common.POINT_CLOUD_TYPE.AR:
        return "AR";
      default:
        return undefined;
    }
  }
}